export enum RolePriorityEnum {
    Member = 0,
    MemberPlus = 1,
    MemberSwitch = 2,
    Admin = 10,
    AdminPlus = 11,
    AdminSuper = 12,
}
